import React, { useState } from "react";
import "../styles/Filters.css";

const Genres = [
  { value: "", label: "All" },
  { value: "action", label: "Action" },
  { value: "rpg", label: "RPG" },
  { value: "adventure", label: "Adventure" },
  { value: "shooter", label: "Shooter" },
  { value: "sports", label: "Sports" },
  // Add more genres here
];
const Platforms = [
  { value: "", label: "All" },
  { value: "pc", label: "PC" },
  { value: "playstation", label: "PlayStation" },
  { value: "xbox", label: "Xbox" },
  { value: "nintendo", label: "Nintendo" },
  // Add more platforms here
];

const Filters = ({ onFilterChange }) => {
  const [genre, setGenre] = useState("");
  const [platform, setPlatform] = useState("");
  const [year, setYear] = useState("");

  const handleApply = () => {
    onFilterChange({ genre, platform, year });
  };

  const handleClear = () => {
    setGenre("");
    setPlatform("");
    setYear("");
    onFilterChange({ genre: "", platform: "", year: "" });
  };

  return (
    <div className="filters-container">
      <label className="filter-label" htmlFor="genre">
        Genre
        <select
          className="filter-select"
          id="genre"
          value={genre}
          onChange={e => setGenre(e.target.value)}
        >
          {Genres.map((g) => (
            <option key={g.value} value={g.value}>{g.label}</option>
          ))}
        </select>
      </label>

      <label className="filter-label" htmlFor="platform">
        Platform
        <select
          className="filter-select"
          id="platform"
          value={platform}
          onChange={e => setPlatform(e.target.value)}
        >
          {Platforms.map((p) => (
            <option key={p.value} value={p.value}>{p.label}</option>
          ))}
        </select>
      </label>

      <label className="filter-label" htmlFor="year">
        Release Year
        <input
          className="filter-input"
          type="number"
          id="year"
          placeholder="e.g. 2023"
          value={year}
          onChange={e => setYear(e.target.value)}
          min="1970"
          max={new Date().getFullYear() + 1}
        />
      </label>

      <div className="filter-btn-row">
        <button className="filter-button" onClick={handleApply}>
          Apply Filters
        </button>
        <button
          className="filter-button"
          type="button"
          style={{ marginLeft: "12px", background: "#313164", color: "#fff" }}
          onClick={handleClear}
        >
          Clear
        </button>
      </div>
    </div>
  );
};

export default Filters;
